import ReactDOM from 'react-dom/client';
import './styles/reset.css';
import './styles/variables.css';
import './styles/base.css';

import App from './App.jsx';
import { AuthProvider } from './utils/auth.jsx';
import { CartProvider } from './utils/cartContext.jsx';
import { ThemeProvider } from './utils/themeContext.jsx';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <ThemeProvider>
      <AuthProvider>
        <CartProvider>
          <App />
        </CartProvider>
      </AuthProvider>
    </ThemeProvider>
  </GoogleOAuthProvider>
);
